import alertModel from '../../../components/Dialogs/alertModal';
export default {
  name: "Portfolio",
  props: ["portfolioData", "rankingLastRow", "bankingRow","valuationEstimates","isBrokerUser","is_premium"],
  components: { alertModel },
  data() {
    return {
      showAlert: false,
    };
  },
  methods: {
    getTwoFixedVal(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == "" ||
        value ==-100000000000000
      ) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },

    getIntFormat(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      } else {
        return this.formatNumber(parseFloat(value).toFixed(2));
      }
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    popUpMsg(msg) {
      this.showAlert = true;
      this.message = msg;
    },
    cancelModal() {
      this.showAlert = false;
    },
  }
};




// WEBPACK FOOTER //
// ./src/assets/js/Report/Fundamentals.js